export default __webpack_public_path__ + "a83c1c1608f2e8d388bcda261ee744c5.png";